<template>
  <div id="autocomplete" style="position: relative">
    <input class="form-control" :placeholder="placeholder" v-model="query" @input="search" />
    <ul class="list-group" style="position: absolute; width: 100%; z-index: 9999999">
      <li v-bind:key="index" v-for="(suggestion,index) in suggestions" class="list-group-item" @click="choose(suggestion)">
        <a href="javascript:;" v-if="sourcetype === 'INTERNAL'">{{ suggestion.name }}</a>
        <a href="javascript:;" v-else>{{ suggestion.nama }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'autocomplete',
  props: ['placeholder', 'data', 'value', 'resetable', 'depth', 'sourcetype'],
  data: function() {
    return {
      suggestions: [],
      index: [],
      query: ''
    }
  },
  watch: {
    'value': function(val) {
      this.query = val
    }
  },
  methods: {
    choose: function(selected) {
      if(this.sourcetype === 'INTERNAL') {
        this.query = selected.name
        this.suggestions = []

        var result = {
          test: '',
          data: [0,0,0] 
        }

        var index = 0
        selected.parents.forEach(function(topic) {
          result.data[index] = topic.name
          index++
        })
        
        result.data[index] = selected.name
        result.text = selected.name
        this.$emit('selected', result)
        if (this.resetable) this.query = ''
      } else {
        this.query = selected.nama
        this.suggestions = []

        var result = {
          test: '',
          data: [0,0,0] 
        }

        var index = 0
        selected.parents.forEach(function(topic) {
          result.data[index] = topic.id
          index++
        })
        
        result.data[index] = selected.id
        result.text = selected.nama
        this.$emit('selected', result)
        if (this.resetable) this.query = ''
      }
      
    },
    search: function() {
      this.suggestions = []
      if(this.query.length > 0) {
        var context = this
        this.data.forEach(function(node) {
          context.traverse(context.query, node, [], 1)
        })
      }
    },
    traverse: function(query, node, parents, level) {
      if(this.sourcetype === 'INTERNAL') { 
        if((query.length > 3) && node.name.toLowerCase().indexOf(this.query.toLowerCase()) >= 0) {
          var nodepath = ''
          parents.forEach(function(parent) {
            nodepath += parent.name + ' >> '
          })

          this.suggestions.push({id: node.name, name: nodepath + node.name, parents: parents})
        }

        if(parseInt(this.depth) && level === parseInt(this.depth)) {
          return;
        }

        if(node.subs.length === 0) {
          return;
        }

        for(var i=0; i<node.subs.length; i++) {
          this.traverse(query, node.subs[i], parents.concat(node), level+1)
        }
      } else {
        if((query.length > 3) && node.nama.toLowerCase().indexOf(this.query.toLowerCase()) >= 0) {
          var nodepath = ''
          parents.forEach(function(parent) {
            nodepath += parent.nama + ' >> '
          })

          this.suggestions.push({id: node.id, nama: nodepath + node.nama, parents: parents})
        }

        if(parseInt(this.depth) && level === parseInt(this.depth)) {
          return;
        }

        if(node.subs.length === 0) {
          return;
        }

        for(var i=0; i<node.subs.length; i++) {
          this.traverse(query, node.subs[i], parents.concat(node), level+1)
        }
      }

      
    },
    refresh: function() {
      this.query = ''
    },
    refill(val) {
      this.query = val
    }
  },
}
</script>



// WEBPACK FOOTER //
// Autocomplete.vue?274383c2